import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PolicyModal from '../components/PolicyModal';
import RecipeCard from '../components/RecipeCard';
import RecipeInsightModal from '../components/RecipeInsightModal';
import OnboardingJourney from '../components/OnboardingJourney';
import BlogBackToTopButton from '../components/BlogBackToTopButton';
import AkilliPlanlamaGorseli from '../assets/images/hizli-ara.png';
import GununMenusu from '../assets/images/gunun-menusu.png';
import BuzdolabimdaAra from '../assets/images/dolap-sef.png';
import BuzdolabimiDoldur from '../assets/images/buzdolabimda-ara.png';
import YaptigimTarifler from '../assets/images/begeni.png';
import Planla from '../assets/images/planla.png';
import OzelGunlerImg from '../assets/images/ozel-gunler.png';
import AthleteImg from '../assets/images/athlete-main.png';
import DietImg from '../assets/images/diet-main.png';
import AllergenImg from '../assets/images/allergen-main.png';
import AlakartImg from '../assets/images/avangart-main.png';
import HealthPlusImg from '../assets/health-plus-card.png';
import {
  buildIngredientCatalog,
  searchIngredientSuggestions,
  rankLandingRecipes
} from '../lib/landing/landingLabDecisionEngine';

const CHAT_STEPS = [
  { side: 'left', name: 'Ahsen', tone: 'rose', text: 'Bugün ne yemek yapsam... off 😩' },
  { side: 'left', name: 'Aslı', tone: 'violet', text: 'Hahaha aynen 😂' },
  { side: 'right', text: 'Kızlar bunu gördünüz mü? 😲' },
  { side: 'link', title: 'Bana Bir Tarif Ver', desc: 'Akıllı mutfak asistanın', url: 'banabirtarifver.com', emoji: '🧑‍🍳' },
  { side: 'left', name: 'Aslı', tone: 'violet', text: 'Ama dolapta ne olduğunu da bilmiyorum 🤔' },
  { side: 'right', text: 'İşte olayı o 😌' },
  { side: 'right', text: 'Dolabını yazıyorsun, sistem sana ne yapacağını söylüyor.' },
  { side: 'right', text: 'Ay sonuysa bütçeye göre, vakit yoksa hızlı tarif.' }
];

const FALLBACK_FRIDGES = [
  {
    id: 'fridge-1',
    shortLabel: '1. Dolap',
    title: 'Mutfak Yönetim Akışı',
    badge: 'Dengeli',
    ingredients: ['Yoğurt', 'Havuç', 'Pirinç', 'Un', 'Tavuk Göğsü', 'Domates', 'Yeşil Biber', 'Soğan', 'Salatalık', 'Maydanoz', 'Limon', 'Zeytinyağı', 'Domates Salçası'],
    recipes: [
      {
        id: '7',
        name: 'Havuçlu Yoğurt Çorbası',
        title: 'Havuçlu Yoğurt Çorbası',
        imageUrl: '/uploads/categories/havuclu_miso_corbasi_tarifi_1506513740_2255_1771864670791.webp',
        image_url: '/uploads/categories/havuclu_miso_corbasi_tarifi_1506513740_2255_1771864670791.webp',
        serveStyle: 'çorba',
        cookTime: 25,
        calories: 220,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Yoğurt', quantity: 400, unit: 'g', originalText: '400 g Yoğurt' },
          { name: 'Havuç', quantity: 240, unit: 'g', originalText: '2 adet Havuç (240 g)' },
          { name: 'Pirinç', quantity: 60, unit: 'g', originalText: '4 yemek kaşığı Pirinç (60 g)' },
          { name: 'Un', quantity: 32, unit: 'g', originalText: '4 yemek kaşığı Un (32 g)' },
          { name: 'Su', quantity: 1000, unit: 'ml', originalText: '1 litre Su' },
          { name: 'Tuz', quantity: 6, unit: 'g', originalText: '1 çay kaşığı Tuz (6 g)' }
        ],
        priceSnapshot: {
          total: 76.0,
          breakdown: [
            { name: 'Yoğurt', total: 48.0 },
            { name: 'Havuç', total: 12.0 },
            { name: 'Pirinç', total: 8.0 },
            { name: 'Un', total: 6.0 },
            { name: 'Tuz', total: 2.0 }
          ],
          source: 'FALLBACK',
          unknownItems: 0
        }
      },
      {
        id: '20',
        name: 'Tavuk Sote',
        title: 'Tavuk Sote',
        imageUrl: '/uploads/categories/tavuk_sote_1771954503867.jpg',
        image_url: '/uploads/categories/tavuk_sote_1771954503867.jpg',
        serveStyle: 'ana_yemek',
        cookTime: 25,
        calories: 450,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Tavuk Göğsü', quantity: 500, unit: 'g', originalText: '500 g Tavuk Göğsü' },
          { name: 'Domates', quantity: 300, unit: 'g', originalText: '3 adet Domates (300 g)' },
          { name: 'Yeşil Biber', quantity: 200, unit: 'g', originalText: '4 adet Yeşil Biber (200 g)' },
          { name: 'Soğan', quantity: 160, unit: 'g', originalText: '2 adet Soğan (160 g)' },
          { name: 'Zeytinyağı', quantity: 40, unit: 'ml', originalText: '4 yemek kaşığı Zeytinyağı (40 ml)' },
          { name: 'Domates Salçası', quantity: 20, unit: 'g', originalText: '1 yemek kaşığı Domates Salçası (20 g)' }
        ],
        priceSnapshot: {
          total: 184.0,
          breakdown: [
            { name: 'Tavuk Göğsü', total: 120.0 },
            { name: 'Domates', total: 21.0 },
            { name: 'Yeşil Biber', total: 28.0 },
            { name: 'Soğan', total: 8.0 },
            { name: 'Zeytinyağı', total: 6.0 },
            { name: 'Domates Salçası', total: 1.0 }
          ],
          source: 'FALLBACK',
          unknownItems: 0
        }
      },
      {
        id: '4',
        name: 'Çoban Salata',
        title: 'Çoban Salata',
        imageUrl: '/uploads/categories/coban_salata_1771799141223.webp',
        image_url: '/uploads/categories/coban_salata_1771799141223.webp',
        serveStyle: 'salata',
        cookTime: 10,
        calories: 140,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Domates', quantity: 320, unit: 'g', originalText: '4 adet Domates (320 g)' },
          { name: 'Salatalık', quantity: 240, unit: 'g', originalText: '3 adet Salatalık (240 g)' },
          { name: 'Soğan', quantity: 80, unit: 'g', originalText: '1 adet Soğan (80 g)' },
          { name: 'Maydanoz', quantity: 30, unit: 'g', originalText: '1/2 demet Maydanoz (30 g)' },
          { name: 'Limon', quantity: 60, unit: 'g', originalText: '1 adet Limon (60 g)' },
          { name: 'Zeytinyağı', quantity: 20, unit: 'ml', originalText: '2 yemek kaşığı Zeytinyağı (20 ml)' }
        ],
        priceSnapshot: {
          total: 52.0,
          breakdown: [
            { name: 'Domates', total: 22.0 },
            { name: 'Salatalık', total: 12.0 },
            { name: 'Soğan', total: 4.0 },
            { name: 'Maydanoz', total: 5.0 },
            { name: 'Limon', total: 6.0 },
            { name: 'Zeytinyağı', total: 3.0 }
          ],
          source: 'FALLBACK',
          unknownItems: 0
        }
      }
    ]
  },
  {
    id: 'fridge-2',
    shortLabel: '2. Dolap',
    title: 'Azalan Stok',
    badge: 'Hafta Sonu',
    ingredients: ['Kırmızı Mercimek', 'Patates', 'Soğan', 'Kırmızı Soğan', 'Zeytinyağı', 'Sıcak Su', 'Domates Salçası', 'Maydanoz', 'Limon Suyu', 'Kimyon', 'Sumak'],
    recipes: [
      {
        id: '70',
        name: 'Mercimek Çorbası',
        title: 'Mercimek Çorbası',
        imageUrl: '/uploads/categories/mercimek_corbasi_1772228742952.webp',
        image_url: '/uploads/categories/mercimek_corbasi_1772228742952.webp',
        serveStyle: 'çorba',
        cookTime: 30,
        calories: 260,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Kırmızı Mercimek', quantity: 250, unit: 'g', originalText: '1.5 su bardağı Kırmızı Mercimek (250 g)' },
          { name: 'Patates', quantity: 200, unit: 'g', originalText: '2 orta Patates (200 g)' },
          { name: 'Soğan', quantity: 120, unit: 'g', originalText: '1.5 adet Soğan (120 g)' },
          { name: 'Sıcak Su', quantity: 1200, unit: 'ml', originalText: '1.2 litre Sıcak Su' },
          { name: 'Kimyon', quantity: 4, unit: 'g', originalText: '1 tatlı kaşığı Kimyon (4 g)' },
          { name: 'Zeytinyağı', quantity: 20, unit: 'ml', originalText: '2 yemek kaşığı Zeytinyağı (20 ml)' }
        ],
        priceSnapshot: { total: 68.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      },
      {
        id: '8',
        name: 'Salçalı Patates Yemeği',
        title: 'Salçalı Patates Yemeği',
        imageUrl: '/uploads/categories/sal__al___patates_yeme__i_1771867274887.jpg',
        image_url: '/uploads/categories/sal__al___patates_yeme__i_1771867274887.jpg',
        serveStyle: 'ana_yemek',
        cookTime: 35,
        calories: 390,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Patates', quantity: 700, unit: 'g', originalText: '7 orta Patates (700 g)' },
          { name: 'Soğan', quantity: 120, unit: 'g', originalText: '1.5 adet Soğan (120 g)' },
          { name: 'Domates Salçası', quantity: 24, unit: 'g', originalText: '1.5 yemek kaşığı Domates Salçası (24 g)' },
          { name: 'Zeytinyağı', quantity: 30, unit: 'ml', originalText: '3 yemek kaşığı Zeytinyağı (30 ml)' },
          { name: 'Sıcak Su', quantity: 600, unit: 'ml', originalText: '600 ml Sıcak Su' },
          { name: 'Tuz', quantity: 6, unit: 'g', originalText: '1 çay kaşığı Tuz (6 g)' }
        ],
        priceSnapshot: { total: 74.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      },
      {
        id: '10',
        name: 'Soğan Salatası',
        title: 'Soğan Salatası',
        imageUrl: '/uploads/categories/sumakli_sogan_salatasi_tarifi_nasil_yapilir_1680764254_6028_1771868750612.webp',
        image_url: '/uploads/categories/sumakli_sogan_salatasi_tarifi_nasil_yapilir_1680764254_6028_1771868750612.webp',
        serveStyle: 'salata',
        cookTime: 12,
        calories: 120,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Kırmızı Soğan', quantity: 300, unit: 'g', originalText: '3 orta Kırmızı Soğan (300 g)' },
          { name: 'Maydanoz', quantity: 40, unit: 'g', originalText: '1 küçük demet Maydanoz (40 g)' },
          { name: 'Limon Suyu', quantity: 20, unit: 'ml', originalText: '2 yemek kaşığı Limon Suyu (20 ml)' },
          { name: 'Sumak', quantity: 6, unit: 'g', originalText: '2 tatlı kaşığı Sumak (6 g)' },
          { name: 'Zeytinyağı', quantity: 10, unit: 'ml', originalText: '1 yemek kaşığı Zeytinyağı (10 ml)' },
          { name: 'Tuz', quantity: 4, unit: 'g', originalText: '1 çay kaşığı Tuz (4 g)' }
        ],
        priceSnapshot: { total: 28.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      }
    ]
  },
  {
    id: 'fridge-3',
    shortLabel: '3. Dolap',
    title: 'Kurtarma Modu',
    badge: 'Son Gün',
    ingredients: ['Kırmızı Mercimek', 'Yeşil Mercimek', 'Patates', 'Soğan', 'Havuç', 'Marul', 'Mor Lahana', 'Limon', 'Zeytinyağı', 'Sıcak Su', 'Kimyon', 'Tuz'],
    recipes: [
      {
        id: '70',
        name: 'Mercimek Çorbası',
        title: 'Mercimek Çorbası',
        imageUrl: '/uploads/categories/mercimek_corbasi_1772228742952.webp',
        image_url: '/uploads/categories/mercimek_corbasi_1772228742952.webp',
        serveStyle: 'çorba',
        cookTime: 30,
        calories: 260,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Kırmızı Mercimek', quantity: 250, unit: 'g', originalText: '1.5 su bardağı Kırmızı Mercimek (250 g)' },
          { name: 'Sıcak Su', quantity: 1200, unit: 'ml', originalText: '1.2 litre Sıcak Su' },
          { name: 'Soğan', quantity: 120, unit: 'g', originalText: '1.5 adet Soğan (120 g)' },
          { name: 'Kimyon', quantity: 4, unit: 'g', originalText: '1 tatlı kaşığı Kimyon (4 g)' },
          { name: 'Tuz', quantity: 6, unit: 'g', originalText: '1 çay kaşığı Tuz (6 g)' }
        ],
        priceSnapshot: { total: 61.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      },
      {
        id: '67',
        name: 'Mercimek Yemeği',
        title: 'Mercimek Yemeği',
        imageUrl: '/uploads/categories/mercimek_yemegi_1772225061890.webp',
        image_url: '/uploads/categories/mercimek_yemegi_1772225061890.webp',
        serveStyle: 'ana_yemek',
        cookTime: 35,
        calories: 410,
        difficulty: 'Orta',
        servings: 4,
        malzemeler: [
          { name: 'Yeşil Mercimek', quantity: 260, unit: 'g', originalText: '1.5 su bardağı Yeşil Mercimek (260 g)' },
          { name: 'Patates', quantity: 300, unit: 'g', originalText: '3 orta Patates (300 g)' },
          { name: 'Soğan', quantity: 120, unit: 'g', originalText: '1.5 adet Soğan (120 g)' },
          { name: 'Havuç', quantity: 120, unit: 'g', originalText: '1 adet Havuç (120 g)' },
          { name: 'Zeytinyağı', quantity: 24, unit: 'ml', originalText: '2.5 yemek kaşığı Zeytinyağı (24 ml)' },
          { name: 'Tuz', quantity: 6, unit: 'g', originalText: '1 çay kaşığı Tuz (6 g)' }
        ],
        priceSnapshot: { total: 83.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      },
      {
        id: '95',
        name: 'Mevsim Salatası',
        title: 'Mevsim Salatası',
        imageUrl: '/uploads/categories/mevsim_salata_1772466634267.jpg',
        image_url: '/uploads/categories/mevsim_salata_1772466634267.jpg',
        serveStyle: 'salata',
        cookTime: 10,
        calories: 150,
        difficulty: 'Kolay',
        servings: 4,
        malzemeler: [
          { name: 'Marul', quantity: 250, unit: 'g', originalText: '1 küçük Marul (250 g)' },
          { name: 'Mor Lahana', quantity: 180, unit: 'g', originalText: '1/2 Mor Lahana (180 g)' },
          { name: 'Limon', quantity: 60, unit: 'g', originalText: '1 adet Limon (60 g)' },
          { name: 'Zeytinyağı', quantity: 20, unit: 'ml', originalText: '2 yemek kaşığı Zeytinyağı (20 ml)' },
          { name: 'Tuz', quantity: 4, unit: 'g', originalText: '1 çay kaşığı Tuz (4 g)' }
        ],
        priceSnapshot: { total: 49.0, breakdown: [], source: 'FALLBACK', unknownItems: 0 }
      }
    ]
  }
];

const MEAL_LABELS = ['Çorba', 'Ana Yemek', 'Salata'];
const LANDING_DEMO_PORTION = 4;

function normalizeMealText(value = '') {
  return String(value).toLocaleLowerCase('tr-TR');
}

function detectMealType(recipe = {}) {
  const tokens = [
    recipe?.serveStyle,
    recipe?.presentation?.courseType,
    recipe?.category,
    recipe?.mealType,
    recipe?.dishType,
    recipe?.recipeType,
    recipe?.name,
    recipe?.title
  ]
    .map((x) => normalizeMealText(x))
    .filter(Boolean)
    .join(' ');

  if (/(corba|çorba|soup)/.test(tokens)) return 'soup';
  if (/(salata|salad|meze)/.test(tokens)) return 'salad';
  if (/(ana yemek|anayemek|main|yemek|et|tavuk)/.test(tokens)) return 'main';
  return 'other';
}

function ensureLandingRecipeImage(recipe = {}) {
  const current = recipe.image_url || recipe.imageUrl || '';
  if (!current) return recipe;
  // Never replace real recipe images with external demo images.
  // Only normalize duplicated fields when image exists.
  return { ...recipe, imageUrl: current, image_url: current };
}

function prepareLandingFridges(items = []) {
  return (items || []).map((f) => ({
    ...f,
    recipes: (f.recipes || []).map((r) => {
      const withImage = ensureLandingRecipeImage(r);
      const appliedPortion = Number(withImage.presentation?.appliedPortion || withImage.targetPortion || withImage.servings || LANDING_DEMO_PORTION);
      return {
        ...withImage,
        servings: Number(withImage.servings || LANDING_DEMO_PORTION),
        targetPortion: Number(withImage.targetPortion || appliedPortion || LANDING_DEMO_PORTION),
        isPreScaled: true,
        presentation: {
          ...(withImage.presentation || {}),
          isPreScaled: true,
          isAlreadyScaled: true,
          appliedPortion,
          baseServings: 1
        },
        priceSnapshot: withImage.priceSnapshot
          ? {
            ...withImage.priceSnapshot,
            portionBasis: Number(withImage.priceSnapshot.portionBasis || appliedPortion || LANDING_DEMO_PORTION),
            isAlreadyScaled: true
          }
          : withImage.priceSnapshot,
        demoData: {
          ...(withImage.demoData || {}),
          isDemoInventory: true,
          signalSource: 'demo'
        }
      };
    })
  }));
}

function normalizeSlotName(value = '') {
  return String(value || '')
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .replace(/[^a-z0-9]/g, '');
}

const LANDING_STAPLE_KEYS = new Set([
  'su',
  'sicaksu',
  'icmesuyu',
  'tuz',
  'karabiber',
  'zeytinyagi',
  'aycicekyagi',
  'seker',
  'ekmek',
  'sut',
  'yumurta'
]);

const LANDING_INFO_CARDS = [
  {
    key: 'hizli_tarif_ara',
    title: 'Hızlı Tarif Ara',
    description: 'Elindeki malzemelerle yapabileceğin tarifleri hızlıca gösterir ve mutfağındaki kararsızlığı azaltır.',
    imageSrc: AkilliPlanlamaGorseli
  },
  {
    key: 'gunun_menusu',
    title: 'Günün Menüsü',
    description: 'Bugün ne pişireceğini düşünmeden, sana uygun seçilmiş çorba ve ana yemek akışı sunar.',
    imageSrc: GununMenusu
  },
  {
    key: 'buzdolabimda_ara',
    title: 'Buzdolabımda Ara',
    description: 'Dolabındaki ürünlere göre çalışan akıllı öneri akışıdır. Stok odaklı tarif bulmanı sağlar.',
    imageSrc: BuzdolabimdaAra
  },
  {
    key: 'buzdolabimi_doldur',
    title: 'Buzdolabımı Doldur',
    description: 'Stoklarını sisteme girersin, sonraki tüm akıllı menüler bu verinin üstünden oluşur.',
    imageSrc: BuzdolabimiDoldur
  },
  {
    key: 'yaptigim_tarifler_favorilerim',
    title: 'Yaptığım Tarifler / Favorilerim',
    description: 'Beğendiğin ve yaptığın tarifleri saklar; sistemin seni daha iyi tanımasına yardımcı olur.',
    imageSrc: YaptigimTarifler
  },
  {
    key: 'planlayin',
    title: 'Planlayın',
    description: 'Porsiyon, hedef ve mutfak düzenine göre sana daha planlı bir yemek akışı kurar.',
    imageSrc: Planla
  }
];

const LANDING_INFO_MODAL_CONTENT = {
  hizli_tarif_ara: {
    title: 'Hızlı Tarif Ara',
    message: 'Şefim; elindeki malzemelere göre uygun tarifleri hızlıca bulur. Kararsız kaldığında en kısa yoldan pişirmeye başlamanı sağlar.',
    icon: 'fa-magnifying-glass'
  },
  gunun_menusu: {
    title: 'Günün Menüsü',
    message: 'Şefim; günün ritmine göre çorba, ana yemek ve yardımcı tarif akışı önerir. Bugün ne yapsam yükünü azaltır.',
    icon: 'fa-calendar-day'
  },
  buzdolabimda_ara: {
    title: 'Buzdolabımda Ara',
    message: 'Şefim; dolabındaki mevcut ürünleri temel alır ve gerçekten yapılabilir tarifleri öne çıkarır. Stok odaklı karar aldırır.',
    icon: 'fa-refrigerator'
  },
  buzdolabimi_doldur: {
    title: 'Buzdolabımı Doldur',
    message: 'Şefim; mutfak stokunu sisteme kaydetmeni sağlar. Sonraki tüm öneri, maliyet ve eksik analizleri bu veriyle daha doğru çalışır.',
    icon: 'fa-box-open'
  },
  yaptigim_tarifler_favorilerim: {
    title: 'Yaptığım Tarifler / Favorilerim',
    message: 'Şefim; sevdiğin ve yaptığın tarifleri hafızada tutar. Böylece sistem zamanla damak zevkini öğrenip daha iyi öneriler üretir.',
    icon: 'fa-heart'
  },
  planlayin: {
    title: 'Planlayın',
    message: 'Şefim; porsiyon, hedef ve mutfak düzenine göre daha planlı bir yemek akışı kurar. Günlük karar yükünü düşürür.',
    icon: 'fa-clock'
  }
};

const LANDING_PREMIUM_CARDS = [
  {
    title: 'Akıllı Planlama (Premium)',
    description: 'Haftalık plan kurar, menü tekrarını azaltır ve market mantığını daha akıllı hale getirir.',
    imageSrc: Planla
  },
  {
    title: 'Sağlıklı Tarifler (Premium)',
    description: 'Diyet ve hedef bazlı akışlarla, beslenme amacına daha uygun öğünler üretir.',
    imageSrc: GununMenusu
  },
  {
    title: 'Sıfır Atık (Premium)',
    description: 'Dolaptaki ürünleri değerlendirip israfı azaltmaya odaklanan tarif ve mutfak akışları sunar.',
    imageSrc: Planla
  }
];

const LANDING_HOME_PREMIUM_CARDS = [
  {
    key: 'allergen',
    title: 'Alerjen Mutfağı',
    description: 'Güvenli içerik taraması ve alerjen uyarıları ile ailen için daha kontrollü menüler kurar.',
    imageSrc: AllergenImg,
    imageClass: 'scale-105'
  },
  {
    key: 'alakart',
    title: 'Alakart Menü',
    description: '7 günlük planı otomatik kurar, eksikleri satın alma listesine ekleyerek karar yükünü azaltır.',
    imageSrc: AlakartImg,
    imageClass: 'scale-140'
  },
  {
    key: 'diet',
    title: 'Diyet Mutfağı',
    description: 'Kalori ve hedef odaklı günlük öğünler oluşturarak sağlıklı yaşam akışını destekler.',
    imageSrc: DietImg,
    imageClass: 'scale-105'
  },
  {
    key: 'athlete',
    title: 'Sporcu Mutfağı',
    description: 'Makro dengeli tariflerle antrenman ve toparlanma günlerine uygun performans menüleri sunar.',
    imageSrc: AthleteImg,
    imageClass: 'scale-105'
  },
  {
    key: 'special_days',
    title: 'Özel Günler Mutfağı',
    description: 'Doğum günü ve davet sofraları için menü, eksik malzeme ve alışveriş akışlarını tek yerden yönetir.',
    imageSrc: OzelGunlerImg,
    imageClass: 'scale-105'
  },
  {
    key: 'health_plus',
    title: 'Sağlık+',
    description: 'Aile bireyi ve hedef odaklı sinyallerle tarif sıralamasını kişiselleştirir, daha doğru menü kararları üretir.',
    imageSrc: HealthPlusImg,
    imageClass: 'scale-105'
  }
];

const LANDING_PREMIUM_LOCK_INFO = {
  allergen: {
    title: 'Alerjen Mutfağı',
    message: 'Şefim; Alerjen Mutfağı, ailen için güvenli tarif seçimi yapmana yardım eder. İçerikleri tarar, riskli malzemeleri öne çıkarır ve daha kontrollü bir mutfak akışı sağlar.',
    icon: 'fa-shield-halved'
  },
  alakart: {
    title: 'Alakart Menü',
    message: 'Şefim; Alakart Menü 7 günlük planı otomatik kurar, mutfağındaki eksikleri listeler ve satın alma kararını hızlandırır. Kararsızlığı azaltan güçlü bir premium akıştır.',
    icon: 'fa-wand-magic-sparkles'
  },
  diet: {
    title: 'Diyet Mutfağı',
    message: 'Şefim; Diyet Mutfağı kalori ve hedef odaklı akışlar üretir. Kişisel hedeflerine uygun menülerle sağlıklı yaşam ritmini daha sürdürülebilir hale getirir.',
    icon: 'fa-apple-whole'
  },
  athlete: {
    title: 'Sporcu Mutfağı',
    message: 'Şefim; Sporcu Mutfağı antrenman temposuna uygun makro dengeli menüler sunar. Performans ve toparlanma odaklı tariflerle süreci daha profesyonel yönetmene yardımcı olur.',
    icon: 'fa-dumbbell'
  },
  special_days: {
    title: 'Özel Günler Mutfağı',
    message: 'Şefim; Özel Günler Mutfağı doğum günü ve davet sofralarında menü, eksik malzeme ve plan akışını tek yerden yönetmeni sağlar.',
    icon: 'fa-cake-candles'
  },
  health_plus: {
    title: 'Sağlık+',
    message: 'Şefim; Sağlık+ öneri sıralamasını aile bireylerine ve hedeflerine göre kişiselleştirir. Böylece daha doğru tarifleri daha hızlı görürsün.',
    icon: 'fa-heart-pulse'
  }
};

// Landing kartı → /nasil-calisir sayfasındaki ilgili modül anchor'ı (key = kart key'i, değer = modül key'i).
// Eşleşmeyen kartlarda "Nasıl çalışır?" linki gösterilmez.
const HOW_IT_WORKS_ANCHORS = {
  hizli_tarif_ara: 'hizli-tarif-ara',
  buzdolabimda_ara: 'buzdolabimda-ara',
  buzdolabimi_doldur: 'mutfagim',
  yaptigim_tarifler_favorilerim: 'favorilerim',
  planlayin: 'mutfak-planlayici',
  allergen: 'alerjen-mutfagi',
  alakart: 'alakart-menu',
  diet: 'diyet-mutfagi',
  athlete: 'sporcu-mutfagi',
  special_days: 'ozel-gunler'
};

const toneClasses = {
  rose: {
    avatar: 'bg-rose-100 text-rose-600',
    name: 'text-rose-600'
  },
  violet: {
    avatar: 'bg-violet-100 text-violet-600',
    name: 'text-violet-600'
  }
};

function ChatBubble({ step }) {
  if (step.side === 'right') {
    return (
      <div className="ml-auto max-w-[85%] animate-[slideInRight_.35s_ease]">
        <div className="rounded-2xl rounded-tr-md bg-primary px-4 py-3 text-sm leading-relaxed text-white shadow-lg shadow-primary/20">
          {step.text}
        </div>
      </div>
    );
  }

  if (step.side === 'link') {
    return (
      <div className="ml-auto max-w-[85%] animate-[slideInRight_.35s_ease]">
        <div className="overflow-hidden rounded-2xl rounded-tr-md bg-primary shadow-lg shadow-primary/20">
          <div className="flex items-start gap-3 bg-white/10 px-4 py-4 text-white">
            <div className="text-2xl">{step.emoji}</div>
            <div className="min-w-0">
              <div className="font-bold">{step.title}</div>
              <div className="text-xs text-white/80">{step.desc}</div>
              <div className="mt-3 flex items-center justify-between rounded-xl bg-white/15 px-3 py-2 text-xs font-semibold ring-1 ring-white/10">
                <span className="truncate">{step.url}</span>
                <span className="material-symbols-outlined text-base">open_in_new</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const tone = toneClasses[step.tone] || toneClasses.rose;
  return (
    <div className="max-w-[85%] animate-[slideInLeft_.35s_ease]">
      <div className="flex items-start gap-3">
        <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${tone.avatar}`}>
          <span className="material-symbols-outlined text-lg">face</span>
        </div>
        <div>
          <div className={`mb-1 ml-1 text-[11px] font-bold ${tone.name}`}>{step.name}</div>
          <div className="rounded-2xl rounded-tl-md bg-white px-4 py-3 text-sm leading-relaxed text-slate-700 shadow-sm ring-1 ring-black/5 dark:bg-slate-900 dark:text-slate-100">
            {step.text}
          </div>
        </div>
      </div>
    </div>
  );
}

// "Mutfak kararı verir" kutusunda dönen yetenek alıntıları (eski hero chip'leri).
const CAPABILITY_QUOTES = [
  'Stoka göre yemek önerir',
  'Haftalık yemek planı kurar',
  'Porsiyona göre hesaplar',
  'Bütçeni önemser',
  'Bebekli aileleri düşünür',
  'Alerjenleri görünür kılar',
  'Son tarihi yaklaşanları hatırlatır',
  'Artan malzemeleri değerlendirir',
  'Öğün rutinine göre çalışır'
];

function CapabilityQuoteSlider() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % CAPABILITY_QUOTES.length), 2800);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="mt-4 flex min-h-[2.5rem] items-center gap-2 border-l-2 border-primary/40 pl-3">
      <span className="material-symbols-outlined text-[18px] text-primary/60">format_quote</span>
      <p key={i} className="animate-fade-in-up text-sm font-semibold italic text-slate-700 dark:text-slate-200">
        {CAPABILITY_QUOTES[i]}
      </p>
    </div>
  );
}

export default function LandingLab({ isDarkMode, toggleDarkMode }) {
  const [visibleCount, setVisibleCount] = useState(0);
  const [activeFridge, setActiveFridge] = useState(FALLBACK_FRIDGES[0].id);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [fridges, setFridges] = useState(() => prepareLandingFridges(FALLBACK_FRIDGES));
  const [fridgeIngredientsState, setFridgeIngredientsState] = useState({});
  const [ingredientQuery, setIngredientQuery] = useState('');
  const [loadingFridges, setLoadingFridges] = useState(true);
  const [activePolicy, setActivePolicy] = useState(null);
  const [premiumLockModal, setPremiumLockModal] = useState(null);
  const [deferredInstallPrompt, setDeferredInstallPrompt] = useState(null);
  const [showIosInstallHelp, setShowIosInstallHelp] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const chatScrollRef = useRef(null);
  const isStandalone = useMemo(
    () => (typeof window !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches) || (typeof navigator !== 'undefined' && navigator.standalone === true),
    []
  );
  const isIos = useMemo(() => {
    if (typeof navigator === 'undefined') return false;
    return /iPad|iPhone|iPod/i.test(navigator.userAgent);
  }, []);
  const isAndroid = useMemo(() => {
    if (typeof navigator === 'undefined') return false;
    return /Android/i.test(navigator.userAgent);
  }, []);

  useEffect(() => {
    let disposed = false;
    const timers = [];

    const scheduleCycle = () => {
      if (disposed) return;
      setVisibleCount(0);

      CHAT_STEPS.forEach((_, index) => {
        const timer = window.setTimeout(() => {
          if (!disposed) setVisibleCount(index + 1);
        }, 700 + index * 900);
        timers.push(timer);
      });

      const resetTimer = window.setTimeout(() => {
        if (!disposed) scheduleCycle();
      }, 700 + CHAT_STEPS.length * 900 + 1800);
      timers.push(resetTimer);
    };

    scheduleCycle();

    return () => {
      disposed = true;
      timers.forEach(window.clearTimeout);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = selectedRecipe ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedRecipe]);

  useEffect(() => {
    const node = chatScrollRef.current;
    if (!node) return;
    node.scrollTo({
      top: node.scrollHeight,
      behavior: visibleCount <= 1 ? 'auto' : 'smooth'
    });
  }, [visibleCount]);

  useEffect(() => {
    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredInstallPrompt(event);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        setLoadingFridges(true);
        const response = await fetch(`${API_BASE_URL}/api/recipes/demo-fridges`, {
          credentials: 'include'
        });
        if (!response.ok) throw new Error(`demo-fridges failed: ${response.status}`);
        const data = await response.json();
        if (active && data?.success && Array.isArray(data.fridges)) {
          const hasAnyRecipe = data.fridges.some((f) => Array.isArray(f?.recipes) && f.recipes.length > 0);
          if (!hasAnyRecipe) {
            console.warn('[LandingLab] demo-fridges returned empty recipes, keeping local fallback recipes.');
            return;
          }

          const normalizedFridges = prepareLandingFridges(data.fridges);

          setFridges(normalizedFridges);
          const initialState = {};
          normalizedFridges.forEach((f) => {
            initialState[f.id] = Array.isArray(f.ingredients) ? [...f.ingredients] : [];
          });
          setFridgeIngredientsState(initialState);
        }
      } catch (error) {
        console.warn('[LandingLab] demo-fridges fallback:', error.message);
      } finally {
        if (active) setLoadingFridges(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  const visibleSteps = useMemo(() => CHAT_STEPS.slice(0, visibleCount), [visibleCount]);
  const fridge = fridges.find((item) => item.id === activeFridge) || fridges[0] || FALLBACK_FRIDGES[0];
  const activeIngredients = fridgeIngredientsState[fridge.id] || fridge.ingredients || [];
  const baseIngredientKeySet = useMemo(
    () => new Set((fridge.ingredients || []).map(normalizeSlotName).filter(Boolean)),
    [fridge]
  );

  const ingredientCatalog = useMemo(() => buildIngredientCatalog(fridges), [fridges]);
  const handlePremiumCardClick = (premiumKey) => {
    const base = LANDING_PREMIUM_LOCK_INFO[premiumKey] || LANDING_INFO_MODAL_CONTENT[premiumKey];
    if (!base) return;
    setPremiumLockModal({ ...base, howItWorksAnchor: HOW_IT_WORKS_ANCHORS[premiumKey] || null });
  };
  const ingredientSuggestions = useMemo(
    () => searchIngredientSuggestions(ingredientQuery, activeIngredients, ingredientCatalog),
    [ingredientQuery, activeIngredients, ingredientCatalog]
  );

  const candidateRecipes = useMemo(() => {
    const activePool = Array.isArray(fridge?.recipes) ? fridge.recipes : [];
    if (activePool.length > 0) return activePool;

    const pool = [];
    const seen = new Set();
    for (const f of fridges) {
      for (const r of f?.recipes || []) {
        const key = String(r?.id || r?.name || '').trim();
        if (!key || seen.has(key)) continue;
        seen.add(key);
        pool.push(r);
      }
    }
    return pool;
  }, [fridge, fridges]);

  const rankedRecipes = useMemo(
    () => rankLandingRecipes(candidateRecipes, activeIngredients),
    [candidateRecipes, activeIngredients]
  );
  const topRecipes = useMemo(() => {
    const used = new Set();
    const ordered = [];
    const wanted = ['soup', 'main', 'salad'];

    for (const type of wanted) {
      const found = rankedRecipes.find((entry) => {
        const key = String(entry?.recipe?.id || entry?.recipe?.name || '').trim();
        if (!key || used.has(key)) return false;
        return detectMealType(entry.recipe) === type;
      });
      if (found) {
        const key = String(found?.recipe?.id || found?.recipe?.name || '').trim();
        used.add(key);
        ordered.push(found);
      }
    }

    for (const entry of rankedRecipes) {
      if (ordered.length >= 3) break;
      const key = String(entry?.recipe?.id || entry?.recipe?.name || '').trim();
      if (!key || used.has(key)) continue;
      used.add(key);
      ordered.push(entry);
    }

    return ordered.slice(0, 3);
  }, [rankedRecipes]);

  const addIngredientToActiveFridge = (ingredient) => {
    if (!ingredient) return;
    setFridgeIngredientsState((prev) => {
      const current = prev[fridge.id] || fridge.ingredients || [];
      if (current.includes(ingredient)) return prev;
      return {
        ...prev,
        [fridge.id]: [...current, ingredient]
      };
    });
    setIngredientQuery('');
  };

  const removeIngredientFromActiveFridge = (ingredient) => {
    setFridgeIngredientsState((prev) => {
      const current = prev[fridge.id] || fridge.ingredients || [];
      return {
        ...prev,
        [fridge.id]: current.filter((x) => x !== ingredient)
      };
    });
  };

  const handleAndroidInstall = async () => {
    if (isStandalone) return;
    if (deferredInstallPrompt) {
      deferredInstallPrompt.prompt();
      try {
        await deferredInstallPrompt.userChoice;
      } catch (_) {
        // no-op
      } finally {
        setDeferredInstallPrompt(null);
      }
      return;
    }
    setShowIosInstallHelp(false);
  };

  const handleIosInstall = () => {
    if (isStandalone) return;
    setShowIosInstallHelp((prev) => !prev);
  };

  const addMissingIngredientsToLandingFridge = (missingItems = []) => {
    const normalizedMissing = (Array.isArray(missingItems) ? missingItems : [])
      .map((item) => (typeof item === 'string' ? item : (item?.name || item?.ingredientName || item?.ingredient_name || '')))
      .map((v) => String(v || '').trim())
      .filter(Boolean);
    if (normalizedMissing.length === 0) return;

    const targetFridgeId = selectedRecipe?._landingFridgeId || activeFridge;
    const targetFridge = fridges.find((f) => f.id === targetFridgeId);

    setFridgeIngredientsState((prev) => {
      const current = prev[targetFridgeId] || targetFridge?.ingredients || [];
      const currentNorm = new Set(current.map(normalizeSlotName).filter(Boolean));
      const toAppend = normalizedMissing.filter((name) => !currentNorm.has(normalizeSlotName(name)));
      if (toAppend.length === 0) {
        return prev;
      }

      const nextIngredients = [...current, ...toAppend];
      const slotSet = new Set(
        [...nextIngredients, 'Su', 'Sıcak Su', 'Tuz', 'İçme Suyu']
          .map(normalizeSlotName)
          .filter(Boolean)
      );

      // Landing modal should react instantly without close/reopen.
      setSelectedRecipe((prevRecipe) => {
        if (!prevRecipe) return prevRecipe;
        const prevFridgeId = prevRecipe?._landingFridgeId || activeFridge;
        if (prevFridgeId !== targetFridgeId) return prevRecipe;

        const sourceIngredients = Array.isArray(prevRecipe?.malzemeler)
          ? prevRecipe.malzemeler
          : (Array.isArray(prevRecipe?.ingredients) ? prevRecipe.ingredients : []);

        const withSlotAvailability = sourceIngredients.map((ing) => {
          if (!ing || typeof ing !== 'object') return ing;
          const name = ing.name || ing.ingredient_name || ing.ingredientName || ing?.ingredient?.name || '';
          const key = normalizeSlotName(name);
          const isAvailable = key ? slotSet.has(key) : !!ing.isAvailable;
          return { ...ing, isAvailable };
        });

        const missingNames = withSlotAvailability
          .filter((ing) => !ing?.isAvailable)
          .map((ing) => String(ing?.name || '').trim())
          .filter(Boolean);
        const totalCount = withSlotAvailability.length || 0;
        const missingCount = missingNames.length;
        const matchPercentage = totalCount > 0
          ? Math.max(0, Math.min(100, Math.round(((totalCount - missingCount) / totalCount) * 100)))
          : 100;

        return {
          ...prevRecipe,
          malzemeler: withSlotAvailability,
          ingredients: withSlotAvailability,
          scaledIngredients: withSlotAvailability,
          missingCount,
          missingIngredients: missingNames.map((name) => ({ name })),
          match: {
            ...(prevRecipe?.match || {}),
            matchPercentage,
            missingCount,
            missingIngredients: missingNames.map((name) => ({ name })),
            isFull: missingCount === 0 && matchPercentage >= 100,
            isCookable: missingCount === 0
          }
        };
      });

      return {
        ...prev,
        [targetFridgeId]: nextIngredients
      };
    });
  };

  return (
    <div className="min-h-screen min-h-[100svh] min-h-[100dvh] bg-[linear-gradient(180deg,#fff_0%,#fbfbf8_52%,#f6f8f7_100%)] text-slate-900 dark:bg-[linear-gradient(180deg,#050608_0%,#07090b_40%,#0a0d10_100%)] dark:text-white">
      <style>{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-20px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      <Header
        isDarkMode={isDarkMode}
        toggleDarkMode={toggleDarkMode}
        onMenuToggle={() => setMobileMenuOpen(true)}
        onOpenPolicyModal={setActivePolicy}
      />

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-[70] md:hidden">
          <button
            type="button"
            aria-label="Menüyü kapat"
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          />
          <div className="absolute left-0 top-0 h-full w-[82%] max-w-[320px] bg-white p-5 shadow-2xl dark:bg-[#10151c]">
            <div className="mb-4 flex items-center justify-between">
              <p className="text-sm font-black uppercase tracking-[0.14em] text-primary">Menü</p>
              <button
                type="button"
                className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-bold dark:border-slate-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                Kapat
              </button>
            </div>

            <nav className="space-y-2">
              <a href="#ozellikler" onClick={() => setMobileMenuOpen(false)} className="block rounded-xl bg-slate-100 px-4 py-3 text-sm font-bold dark:bg-slate-800">
                Özellikler
              </a>
              <a href="#premium" onClick={() => setMobileMenuOpen(false)} className="block rounded-xl bg-slate-100 px-4 py-3 text-sm font-bold dark:bg-slate-800">
                Premium Özellikler
              </a>
              <Link to="/sss" onClick={() => setMobileMenuOpen(false)} className="block rounded-xl bg-slate-100 px-4 py-3 text-sm font-bold dark:bg-slate-800">
                S.S.S
              </Link>
              <Link to="/blog" onClick={() => setMobileMenuOpen(false)} className="block rounded-xl bg-slate-100 px-4 py-3 text-sm font-bold dark:bg-slate-800">
                Blog
              </Link>
              <button
                type="button"
                onClick={() => {
                  toggleDarkMode();
                  setMobileMenuOpen(false);
                }}
                className="block w-full rounded-xl bg-primary/10 px-4 py-3 text-left text-sm font-bold text-primary"
              >
                {isDarkMode ? 'Açık Moda Geç' : 'Koyu Moda Geç'}
              </button>
            </nav>
          </div>
        </div>
      )}

      <main className="overflow-x-clip pt-24">
        <section className="px-4 pb-10 pt-6 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.05fr_.95fr] lg:items-center">
            <div className="min-w-0 max-w-2xl">
              <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
                <span className="h-2 w-2 rounded-full bg-primary" />
                Ev İçin Mutfak Yönetim Sistemi
              </div>
              <h1 className="max-w-3xl text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                Mutfağında ne varsa,
                <span className="block text-primary">bugün ne pişireceğini, yarına ne artacağını </span>söyleyelim.
              </h1>
              <p className="mt-5 max-w-xl text-base leading-7 text-slate-600 dark:text-slate-300 sm:text-lg">
                BBTV sadece tarif önermez; evdeki stok, bütçe, kişi sayısı, porsiyon, alerjen ve bebekli aile ihtiyaçlarını birlikte değerlendirerek ne pişireceğine karar vermene yardımcı olur.
              </p>
              <div className="mt-6 rounded-2xl border border-slate-200 bg-white/80 p-4 dark:border-slate-800 dark:bg-slate-900/60">
                <h2 className="text-lg font-black text-slate-900 dark:text-white">Tarif listesi değil, mutfak kararı verir</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Bugün ne pişirsem, evdeki malzemelerle ne yapılır, haftalık yemek planı nasıl kurulur ve son tarihi yaklaşan ürünler nasıl değerlendirilir sorularını tek akışta çözer.
                </p>
                <CapabilityQuoteSlider />
              </div>

              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to="/kayit-ol"
                  className="inline-flex h-12 items-center justify-center rounded-xl bg-primary px-6 text-sm font-bold text-white shadow-lg shadow-primary/20 transition hover:-translate-y-0.5"
                >
                  Kendi mutfağımı kur
                </Link>
                <Link
                  to="/giris-yap"
                  className="inline-flex h-12 items-center justify-center rounded-xl border border-slate-200 bg-white px-6 text-sm font-bold text-slate-700 transition hover:border-primary hover:text-primary dark:border-slate-800 dark:bg-slate-950 dark:text-white"
                >
                  Giriş Yap
                </Link>
                <a
                  href="#mini-buzdolabi"
                  className="inline-flex h-12 items-center justify-center rounded-xl border border-slate-200 bg-white px-6 text-sm font-bold text-slate-700 transition hover:border-primary hover:text-primary dark:border-slate-800 dark:bg-slate-950 dark:text-white"
                >
                  Nasıl çalıştığını gör
                </a>
              </div>

              <div className="mt-5 grid max-w-xl gap-2 sm:grid-cols-2">
                <button
                  type="button"
                  onClick={handleAndroidInstall}
                  disabled={isStandalone}
                  className={`inline-flex h-11 items-center justify-center gap-1.5 rounded-lg border px-3 text-xs font-bold transition ${isStandalone
                    ? 'cursor-not-allowed border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300'
                    : 'border-slate-200 bg-white text-slate-800 hover:border-primary hover:text-primary dark:border-slate-800 dark:bg-slate-950 dark:text-white'
                    }`}
                >
                  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M7.6 8.4 6.2 5.9a.6.6 0 1 1 1-.6l1.4 2.5a8 8 0 0 1 7 0L17 5.3a.6.6 0 1 1 1 .6l-1.4 2.5A6.9 6.9 0 0 1 20 14v5a1 1 0 0 1-2 0v-2h-1v3a1 1 0 0 1-1 1h-1v-5H9v5H8a1 1 0 0 1-1-1v-3H6v2a1 1 0 0 1-2 0v-5a6.9 6.9 0 0 1 3.6-5.6ZM9.5 11a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Zm5 0a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Z"
                    />
                  </svg>
                  {isStandalone ? 'Uygulama Kurulu' : 'Android İçin Yükle'}
                </button>
                <button
                  type="button"
                  onClick={handleIosInstall}
                  disabled={isStandalone}
                  className={`inline-flex h-11 items-center justify-center gap-1.5 rounded-lg border px-3 text-xs font-bold transition ${isStandalone
                    ? 'cursor-not-allowed border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300'
                    : 'border-slate-200 bg-white text-slate-800 hover:border-primary hover:text-primary dark:border-slate-800 dark:bg-slate-950 dark:text-white'
                    }`}
                >
                  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm4 18.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4ZM8 5v11h8V5H8Z"
                    />
                  </svg>
                  {isStandalone ? 'Uygulama Kurulu' : 'iOS İçin Yükle'}
                </button>
              </div>
              {!isStandalone && isAndroid && !deferredInstallPrompt ? (
                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  Android yükleme kartı görünmüyorsa menüden “Uygulamayı yükle” seçeneğini kullan.
                </p>
              ) : null}
              {!isStandalone && showIosInstallHelp ? (
                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  iOS: ⋯ Paylaş → Ana Ekrana Ekle
                </p>
              ) : null}
            </div>

            <div className="relative min-w-0">
              <div className="absolute inset-x-10 top-8 -z-10 h-48 rounded-full bg-primary/15 blur-3xl" />
              <div className="mx-auto w-full max-w-md rounded-[2rem] border border-white/60 bg-white/90 p-3 shadow-2xl shadow-slate-300/40 backdrop-blur dark:border-white/10 dark:bg-slate-950/90 dark:shadow-black/30">
                <div className="overflow-hidden rounded-[1.5rem] border border-slate-200 bg-[#f6f8f7] dark:border-slate-800 dark:bg-[#0a0f0d]">
                  <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-3 dark:border-slate-800 dark:bg-[#06090b]">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/15 text-primary">
                      <span className="material-symbols-outlined">groups</span>
                    </div>
                    <div>
                      <div className="text-sm font-bold">Çılgın Kızlar</div>
                      <div className="text-xs text-slate-500 dark:text-slate-400">Aslı, Gonca, Sinem...</div>
                    </div>
                  </div>
                  <div
                    id="chat-demo"
                    className="flex h-[30rem] flex-col gap-4 overflow-hidden bg-[radial-gradient(#25d46615_0.7px,transparent_0.7px),radial-gradient(#25d46615_0.7px,#f6f8f7_0.7px)] bg-[size:20px_20px] bg-[position:0_0,10px_10px] p-4 dark:bg-[#0a0f0d]"
                  >
                    <div className="flex justify-center">
                      <span className="rounded-full bg-white/80 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500 shadow-sm dark:bg-[#121821] dark:text-slate-400">
                        Bugün
                      </span>
                    </div>
                    <div
                      ref={chatScrollRef}
                      className="flex-1 space-y-4 overflow-y-auto pr-1 scrollbar-hide"
                      style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                    >
                      {visibleSteps.map((step, index) => (
                        <ChatBubble key={`${step.side}-${index}`} step={step} />
                      ))}
                      <div className="h-1" />
                    </div>
                    <div className="flex gap-2 border-t border-slate-200 bg-white px-3 py-3 dark:border-slate-800 dark:bg-[#06090b]">
                      <input
                        readOnly
                        value={visibleCount >= 6 ? 'Dolabını yazıyorsun...' : ''}
                        className="h-11 min-w-0 flex-1 rounded-full bg-slate-100 px-4 text-sm outline-none dark:bg-[#121821]"
                      />
                      <button className="shrink-0 whitespace-nowrap rounded-full bg-primary px-4 text-sm font-bold text-white">
                        Gönder
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="mini-buzdolabi" className="px-4 py-12 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-7xl rounded-[2rem] border border-black/5 bg-white/80 p-6 shadow-xl shadow-slate-200/50 backdrop-blur dark:border-white/10 dark:bg-[#0b0f14] dark:shadow-black/30">
            <div className="mb-8 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <div className="mb-2 text-sm font-bold uppercase tracking-[0.2em] text-primary">Mini buzdolabı</div>
                <h2 className="text-3xl font-black tracking-tight">Dolabı seç, içerideki tarifleri gerçekten gör.</h2>
                <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600 dark:text-slate-300 sm:text-base">
                  Her dolapta farklı stok var. Tarif kartına basınca detay modalı açılıyor. Böylece kullanıcı sadece fikir değil, gerçek ürün akışını hissediyor.
                </p>
                <p className="mt-2 text-xs font-semibold text-primary/90">
                  Yeni modal deneyimi bu bölümde canlı: karttan açıp tam akışı görebilirsin.
                </p>
              </div>
            </div>

            <div className="mb-6 flex flex-wrap gap-2">
              {fridges.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveFridge(item.id)}
                  className={`rounded-full px-4 py-2 text-sm font-bold transition ${activeFridge === item.id
                    ? 'bg-primary text-white shadow-lg shadow-primary/20'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800'
                    }`}
                >
                  {item.shortLabel}
                </button>
              ))}
            </div>

            <div className="grid gap-6 lg:grid-cols-[.74fr_1.26fr]">
              <div className="rounded-[1.5rem] border border-slate-200 bg-[#f6f8f7] p-5 dark:border-slate-800 dark:bg-[#10161d]">
                <div className="mb-4 flex items-center justify-between">
                  <div>
                    <div className="text-sm font-bold text-slate-500 dark:text-slate-400">Seçilen dolap</div>
                    <div className="text-xl font-black">{fridge.title}</div>
                  </div>
                  <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">{fridge.badge}</span>
                </div>

                <div className="mb-4">
                  <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
                    Dolaba malzeme ekle
                  </div>
                  <input
                    value={ingredientQuery}
                    onChange={(e) => setIngredientQuery(e.target.value)}
                    placeholder="Malzeme ara... (örn. domates)"
                    className="mt-2 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm outline-none ring-primary/20 transition focus:ring dark:border-slate-700 dark:bg-slate-950"
                  />
                  {ingredientQuery && ingredientSuggestions.length > 0 && (
                    <div className="mt-2 rounded-xl border border-slate-200 bg-white p-2 shadow-sm dark:border-slate-700 dark:bg-slate-950">
                      {ingredientSuggestions.map((item) => (
                        <button
                          key={item}
                          type="button"
                          onClick={() => addIngredientToActiveFridge(item)}
                          className="block w-full rounded-lg px-3 py-2 text-left text-sm font-semibold text-slate-700 transition hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800"
                        >
                          + {item}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-3">
                  {activeIngredients.map((ingredient) => (
                    (() => {
                      const isAdded = !baseIngredientKeySet.has(normalizeSlotName(ingredient));
                      const cardClass = isAdded
                        ? 'bg-emerald-50 ring-1 ring-emerald-200 dark:bg-emerald-900/20 dark:ring-emerald-700/40'
                        : 'bg-white ring-1 ring-black/5 dark:bg-slate-950 dark:ring-white/10';
                      return (
                        <div
                          key={ingredient}
                          className={`relative flex min-h-[84px] flex-col items-center justify-center rounded-2xl px-3 py-4 text-center shadow-sm ${cardClass}`}
                        >
                          <button
                            type="button"
                            onClick={() => removeIngredientFromActiveFridge(ingredient)}
                            className="absolute right-2 top-2 rounded-full bg-slate-100 px-1.5 py-0.5 text-xs font-black text-slate-500 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
                            title="Malzemeyi çıkar"
                          >
                            ×
                          </button>
                          <span className="material-symbols-outlined mb-2 text-primary">nutrition</span>
                          <span className="text-sm font-semibold">{ingredient}</span>
                          {isAdded && (
                            <span className="mt-1 rounded-full bg-emerald-600 px-2 py-0.5 text-[10px] font-black uppercase tracking-tight text-white">
                              Eklendi
                            </span>
                          )}
                          {LANDING_STAPLE_KEYS.has(normalizeSlotName(ingredient)) && (
                            <span className="mt-1 rounded-full bg-amber-500/15 px-2 py-0.5 text-[10px] font-black uppercase tracking-tight text-amber-700 dark:text-amber-300">
                              Temel Ürün
                            </span>
                          )}
                        </div>
                      );
                    })()
                  ))}
                </div>
              </div>

              <div className="rounded-[1.5rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-[#0d1218]">
                <div className="mb-5 flex items-start justify-between gap-4">
                  <div>
                    <div className="text-sm font-bold text-slate-500 dark:text-slate-400">İçerideki tarifler</div>
                    <div className="mt-1 text-2xl font-black leading-tight">{fridge.title} için önerilen plan</div>
                    <div className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                      Deterministik skor: stok uyumu + eksik ürün + süre + maliyet + (varsa) SKT baskısı
                      <span className="ml-1 font-semibold text-amber-600 dark:text-amber-400">(SKT sinyali: örnek veri)</span>
                    </div>
                  </div>
                  <div className="rounded-2xl bg-slate-50 px-4 py-3 text-right dark:bg-slate-900">
                    <div className="text-xs font-bold uppercase tracking-[0.16em] text-primary">Canlı demo</div>
                    <div className="mt-1 text-lg font-black">{topRecipes.length || 0} tarif</div>
                  </div>
                </div>

                {loadingFridges ? (
                  <div className="rounded-2xl border border-dashed border-slate-200 px-5 py-10 text-center text-sm font-semibold text-slate-500 dark:border-slate-800 dark:text-slate-400">
                    Gerçek tarifler yükleniyor...
                  </div>
                ) : (
                  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {topRecipes.map((entry, index) => {
                      const landingMatch = {
                        matchPercentage: entry.coverageRate,
                        missingCount: entry.missingCount,
                        missingIngredients: (entry.missingItems || []).map((name) => ({ name })),
                        isFull: entry.missingCount === 0 && entry.coverageRate >= 100,
                        isCookable: entry.missingCount === 0
                      };
                      const recipeForCard = ensureLandingRecipeImage({
                        ...(entry.recipe || {}),
                        match: landingMatch,
                        matchPercentage: landingMatch.matchPercentage,
                        missingCount: landingMatch.missingCount,
                        missingIngredients: landingMatch.missingIngredients
                      });
                      return (
                        <div key={recipeForCard?.id || recipeForCard?.name || `recipe-${index}`} className="space-y-2">
                          <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
                            {MEAL_LABELS[index] || `Öğün ${index + 1}`}
                          </div>
                          <RecipeCard
                            recipe={recipeForCard}
                            showTopInsight={false}
                            onCardClick={async () => {
                              const hydrated = recipeForCard;
                              // Landing strict rule: availability is derived from selected slot (not real inventory).
                              const slotSet = new Set(
                                [...activeIngredients, 'Su', 'Sıcak Su', 'Tuz', 'İçme Suyu']
                                  .map(normalizeSlotName)
                                  .filter(Boolean)
                              );
                              const withSlotAvailability = (Array.isArray(hydrated?.malzemeler) ? hydrated.malzemeler : (hydrated?.ingredients || [])).map((ing) => {
                                if (!ing || typeof ing !== 'object') return ing;
                                const name = ing.name || ing.ingredient_name || ing.ingredientName || ing?.ingredient?.name || '';
                                const key = normalizeSlotName(name);
                                const isAvailable = key ? slotSet.has(key) : !!ing.isAvailable;
                                return { ...ing, isAvailable };
                              });

                              const hydratedImage = ensureLandingRecipeImage({
                                ...recipeForCard,
                                ...hydrated
                              });
                              const hydratedFixed = {
                                ...hydrated,
                                ...hydratedImage,
                                _landingFridgeId: fridge.id,
                                demoData: {
                                  ...(recipeForCard?.demoData || {}),
                                  ...(hydrated?.demoData || {}),
                                  isDemoInventory: true,
                                  signalSource: 'demo'
                                },
                                match: landingMatch,
                                missingCount: landingMatch.missingCount,
                                missingIngredients: landingMatch.missingIngredients,
                                // Keep upstream scaling flags to avoid double-scaling in modal.
                                servings: LANDING_DEMO_PORTION,
                                isPreScaled: true,
                                targetPortion: LANDING_DEMO_PORTION,
                                presentation: {
                                  ...(hydrated?.presentation || {}),
                                  isPreScaled: true,
                                  isAlreadyScaled: true,
                                  appliedPortion: LANDING_DEMO_PORTION,
                                  baseServings: 1
                                },
                                priceSnapshot: hydrated?.priceSnapshot ? {
                                  ...hydrated.priceSnapshot,
                                  portionBasis: Number(hydrated?.priceSnapshot?.portionBasis || LANDING_DEMO_PORTION),
                                  isAlreadyScaled: true
                                } : hydrated?.priceSnapshot,
                                costMeta: {
                                  ...(hydrated?.costMeta || {}),
                                  source: hydrated?.costMeta?.source || 'LANDING_DEMO'
                                },
                                malzemeler: withSlotAvailability,
                                ingredients: withSlotAvailability,
                                scaledIngredients: withSlotAvailability
                              };
                              setSelectedRecipe(hydratedFixed);
                            }}
                            hidePrimaryAction
                            isDarkMode={isDarkMode}
                            userProfile={{ hasBaby: false, allergies: [], serving_count: LANDING_DEMO_PORTION, kisi_sayisi: LANDING_DEMO_PORTION }}
                            userPortion={LANDING_DEMO_PORTION}
                          />
                          <div className="rounded-xl border border-rose-100 bg-rose-50 p-3 text-xs text-slate-700 dark:border-rose-900/40 dark:bg-rose-900/10 dark:text-slate-200">
                            <div className="mb-1 font-bold uppercase tracking-[0.14em] text-rose-500">Neden bu?</div>
                            <ul className="space-y-1">
                              <li>✓ Stok uyumu: %{landingMatch.matchPercentage}</li>
                              <li>✓ Eksik malzeme: {landingMatch.missingCount}</li>
                              <li>✓ Hazırlık süresi: {entry.minutes} dk</li>
                              {(entry.facts?.expiryDays ?? null) != null && (
                                <li>✓ SKT baskısı: {entry.facts.expiryDays} gün (örnek veri)</li>
                              )}
                              {(entry.reasons || [])
                                .filter((reason) =>
                                  !reason.startsWith('Stok uyumu:') &&
                                  !reason.startsWith('Eksik malzeme:') &&
                                  !reason.startsWith('Hazırlık süresi:') &&
                                  !reason.startsWith('Son kullanma tarihi (SKT)')
                                )
                                .map((reason) => (
                                  <li key={reason}>✓ {reason}</li>
                                ))}
                            </ul>
                            {(landingMatch.missingIngredients?.length ?? 0) > 0 && (
                              <div className="mt-2 text-[11px] font-semibold text-slate-600 dark:text-slate-300">
                                Eksikler: {landingMatch.missingIngredients.slice(0, 4).map((x) => x?.name).filter(Boolean).join(', ')}
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}

                <div className="mt-8 rounded-2xl bg-primary/5 p-4 dark:bg-primary/10">
                  <div className="text-sm font-bold text-primary">Sonraki adım</div>
                  <p className="mt-2 text-sm leading-6 text-slate-700 dark:text-slate-200">
                    Bu bizim örnek dolaplarımız. Şimdi kendi mutfağını kurarsan sistem senin malzemelerinle gerçekten çalışır.
                  </p>
                  <div className="mt-4 flex flex-wrap gap-3">
                    <Link
                      to="/kayit-ol"
                      className="inline-flex h-11 items-center justify-center rounded-xl bg-primary px-5 text-sm font-bold text-white"
                    >
                      Şimdi senin mutfağını yapalım
                    </Link>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="ozellikler" className="bg-white px-4 pb-16 pt-4 dark:bg-[#050608] sm:px-6 lg:px-8">
          {/* Başlangıç yolculuğu — Program Özellikleri'nin üstünde (deneme/erişim anlatımı) */}
          <OnboardingJourney />

          <div className="mx-auto mt-8 max-w-7xl">
            <div className="mx-auto mb-12 max-w-lg">
              <div className="flex items-center justify-center">
                <div className="h-px flex-grow bg-[#e6dbdb] dark:bg-gray-700" />
                <h3 className="shrink-0 px-4 text-2xl font-black tracking-tight text-slate-900 dark:text-white">
                  Program Özellikleri
                </h3>
                <div className="h-px flex-grow bg-[#e6dbdb] dark:bg-gray-700" />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {LANDING_INFO_CARDS.map((item) => (
                <article
                  key={item.title}
                  onClick={() => handlePremiumCardClick(item.key)}
                  className="group cursor-pointer overflow-hidden rounded-2xl border border-[#e6dbdb] bg-background-light transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg dark:border-gray-800 dark:bg-[#0b0f14] dark:hover:border-primary/30"
                >
                  <div className="flex">
                    <div className="flex min-h-[164px] w-[36%] flex-shrink-0 items-center justify-center p-4">
                      <img src={item.imageSrc} alt={item.title} className="max-h-[120px] w-full object-contain" />
                    </div>
                    <div className="flex w-[64%] flex-col justify-center p-6">
                      <h4 className="text-lg font-bold text-slate-900 dark:text-white">{item.title}</h4>
                      <p className="mt-2 text-sm text-slate-500 dark:text-gray-400">{item.description}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div id="premium" className="mx-auto mt-16 max-w-7xl">
            <div className="mx-auto mb-12 max-w-lg">
              <div className="flex items-center justify-center">
                <div className="h-px flex-grow bg-[#e6dbdb] dark:bg-gray-700" />
                <h3 className="shrink-0 px-4 text-2xl font-black tracking-tight text-slate-900 dark:text-white">
                  Premium Mutfaklar
                </h3>
                <div className="h-px flex-grow bg-[#e6dbdb] dark:bg-gray-700" />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {LANDING_HOME_PREMIUM_CARDS.map((item) => (
                <article
                  key={item.title}
                  onClick={() => handlePremiumCardClick(item.key)}
                  className="group cursor-pointer overflow-hidden rounded-2xl border border-[#e6dbdb] bg-background-light transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg dark:border-gray-800 dark:bg-[#0b0f14] dark:hover:border-primary/30"
                >
                  <div className="flex">
                    <div className="flex min-h-[176px] w-[40%] flex-shrink-0 items-center justify-center p-4">
                      <img
                        src={item.imageSrc}
                        alt={item.title}
                        className={`max-h-[136px] w-full object-contain transition-transform duration-300 ${item.imageClass || ''}`}
                      />
                    </div>
                    <div className="flex w-[60%] flex-col justify-center p-6">
                      <div className="mb-2">
                        <span className="rounded bg-[#cc2b1e] px-1.5 py-0.5 text-[8px] font-black tracking-tighter text-white shadow-sm shadow-red-900/40">
                          PREMIUM
                        </span>
                      </div>
                      <h4 className="text-lg font-bold text-slate-900 dark:text-white">{item.title}</h4>
                      <p className="mt-2 text-sm text-slate-500 dark:text-gray-400">{item.description}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <BlogBackToTopButton />

      <RecipeInsightModal
        isOpen={!!selectedRecipe}
        onClose={() => setSelectedRecipe(null)}
        recipe={selectedRecipe}
        onAddToShoppingList={addMissingIngredientsToLandingFridge}
        isDarkMode={isDarkMode}
        userProfile={{ hasBaby: false, allergies: [], skillLevel: 'Acemi', serving_count: LANDING_DEMO_PORTION, kisi_sayisi: LANDING_DEMO_PORTION }}
        userPortion={LANDING_DEMO_PORTION}
        selectedNarration="flow"
        skillLevel="Acemi"
        availableComponents={[]}
        hideBabyInfo
      />
      <PolicyModal policyKey={activePolicy} open={!!activePolicy} onClose={() => setActivePolicy(null)} />
      {premiumLockModal && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity" onClick={() => setPremiumLockModal(null)} />
          <div className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-[#e6dbdb] bg-white shadow-2xl dark:border-gray-800 dark:bg-[#1a1a1a]">
            <div className="p-8">
              <div className="mb-6 flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                  <i className={`fa-solid ${premiumLockModal.icon} text-2xl`} />
                </div>
                <h3 className="text-2xl font-black text-gray-900 dark:text-white">{premiumLockModal.title}</h3>
              </div>

              <p className="rounded-2xl border border-gray-100 bg-gray-50 p-6 text-lg italic leading-relaxed text-gray-600 dark:border-gray-700 dark:bg-gray-800/50 dark:text-gray-300">
                {premiumLockModal.message}
              </p>

              <div className="mt-4 flex items-center gap-3 rounded-xl border border-amber-100 bg-amber-50 p-4 text-amber-700 dark:border-amber-900/30 dark:bg-amber-900/10 dark:text-amber-400">
                <i className="fa-solid fa-lock text-xl" />
                <span className="text-sm font-bold uppercase tracking-wider">Bu özellik hakkında kısa bilgilendirme.</span>
              </div>

              {premiumLockModal.howItWorksAnchor ? (
                <Link
                  to={`/nasil-calisir#${premiumLockModal.howItWorksAnchor}`}
                  onClick={() => setPremiumLockModal(null)}
                  className="mt-4 flex items-center justify-center gap-2 rounded-2xl border border-primary/30 bg-primary/5 py-3 font-bold text-primary transition-all hover:bg-primary/10"
                >
                  <i className="fa-solid fa-circle-info" />
                  Nasıl çalışır? · Detaylı oku
                </Link>
              ) : null}

              <button
                onClick={() => setPremiumLockModal(null)}
                className="mt-4 w-full rounded-2xl bg-gray-900 py-4 font-black text-white shadow-xl transition-all hover:scale-[1.02] active:scale-95 dark:bg-white dark:text-black"
              >
                Tamam
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
